import React from "react"
import "./style.scss"
import IconArrow from "../../../images/Icon-learnmore.svg"

const Learnmore = ({ text, url, withArrow, className }) => {
  return (
    <div className="learn_more_component">
      <a href={url} className={`${className ? className : ""}`}>
        {text || "Learn more"}
        {withArrow && <img src={IconArrow} alt="learn_more" />}
      </a>
    </div>
  )
}

export default Learnmore
